import {
  IconButton,
  IconName,
  IconSize,
  KebabMenu
} from '@focaldata/cin-ui-components'
import { useAppDispatch, useAppSelector } from '../../../App.store'
import {
  DraftQuestionnaireEntry,
  QuestionSettingCode
} from '../../../data/model/questionnaire'
import useRemoveQuestionnaireSetting from '../../../hooks/questionnaire/useRemoveQuestionnaireSetting'
import { getQuestionSettings } from '../../../utils/questionnaireUtils'
import {
  removeQuestionSetting,
  selectSettingsByQuestionId
} from '../Questionnaire.slice'
import { getEntryId } from '../Questionnaire.utils'
import useEntrySettingValues from './useEntrySettingValues'

interface Props {
  entry: DraftQuestionnaireEntry
}

export const QuestionTimerMenu = ({ entry }: Props) => {
  const removeQuestionnaireSetting = useRemoveQuestionnaireSetting(entry)
  const dispatch = useAppDispatch()
  const entrySettingValues = useEntrySettingValues(entry.number)
  const settingValues =
    useAppSelector((state) =>
      selectSettingsByQuestionId(state, getEntryId(entry))
    ) || entrySettingValues
  const questionSettings = getQuestionSettings(settingValues)

  return (
    <KebabMenu
      kebabMenuOptions={[
        {
          id: 1,
          textItem: 'Delete',
          onClickItem: () => {
            dispatch(
              removeQuestionSetting({
                questionLk: getEntryId(entry),
                settingCode: QuestionSettingCode.QuestionTimer
              })
            )
            removeQuestionnaireSetting([QuestionSettingCode.QuestionTimer])
          }
        }
      ]}
      menuButton={
        <IconButton
          smallHoverShadowSize
          iconName={IconName.AccessTime}
          iconSize={IconSize.Large}
          tooltipText={`${questionSettings.get(
            QuestionSettingCode.QuestionTimer
          )} seconds question timer`}
        />
      }
    />
  )
}
